<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.reportdepartmentsumdetail_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/department/reportdepartmentsumdetail';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        column: [
          {
            label: '收费明细表ID',
            prop: 'id',
            rules: [
              {
                required: true,
                message: '请输入收费明细表ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '区名称',
            prop: 'areaName',
            rules: [
              {
                required: true,
                message: '请输入区名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '栋名称',
            prop: 'buildingName',
            rules: [
              {
                required: true,
                message: '请输入栋名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '单元名称',
            prop: 'unitName',
            rules: [
              {
                required: true,
                message: '请输入单元名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '房号',
            prop: 'roomNum',
            rules: [
              {
                required: true,
                message: '请输入房号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '住户名称',
            prop: 'name',
            rules: [
              {
                required: true,
                message: '请输入住户名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '银行账户',
            prop: 'bankCardNo',
            rules: [
              {
                required: true,
                message: '请输入银行账户',
                trigger: 'change',
              },
            ],
          },
          {
            label: '房租',
            prop: 'rentAmount',
            rules: [
              {
                required: true,
                message: '请输入房租',
                trigger: 'change',
              },
            ],
          },
          {
            label: '电费',
            prop: 'electricityAmount',
            rules: [
              {
                required: true,
                message: '请输入电费',
                trigger: 'change',
              },
            ],
          },
          {
            label: '水费',
            prop: 'waterAmount',
            rules: [
              {
                required: true,
                message: '请输入水费',
                trigger: 'change',
              },
            ],
          },
          {
            label: '物业费',
            prop: 'propertyAmount',
            rules: [
              {
                required: true,
                message: '请输入物业费',
                trigger: 'change',
              },
            ],
          },
          {
            label: '卫生费',
            prop: 'hygienicAmount',
            rules: [
              {
                required: true,
                message: '请输入卫生费',
                trigger: 'change',
              },
            ],
          },
          {
            label: '账单年月',
            prop: 'billcycleDate',
            rules: [
              {
                required: true,
                message: '请输入账单年月',
                trigger: 'change',
              },
            ],
          },
          {
            label: '账单周期',
            prop: 'billcycleNo',
            rules: [
              {
                required: true,
                message: '请输入账单周期',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注1',
            prop: 'remark1',
            rules: [
              {
                required: true,
                message: '请输入备注1',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注2',
            prop: 'remark2',
            rules: [
              {
                required: true,
                message: '请输入备注2',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注3',
            prop: 'remark3',
            rules: [
              {
                required: true,
                message: '请输入备注3',
                trigger: 'change',
              },
            ],
          },
          {
            label: '版本',
            prop: 'version',
            rules: [
              {
                required: true,
                message: '请输入版本',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.reportdepartmentsumdetail_add, false),
        viewBtn: this.vaildData(this.permission.reportdepartmentsumdetail_view, false),
        delBtn: this.vaildData(this.permission.reportdepartmentsumdetail_delete, false),
        editBtn: this.vaildData(this.permission.reportdepartmentsumdetail_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
